'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { Icon } from '@eliadmin/core/src/components/nt/ui/icon';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/** Keep the header trigger while the shared core owns search and its results. */
export function SearchBar({ label }: { label: string }) {
  const { t } = useTranslations();

  return (
    <SearchDrawer
      trigger={
        <button
          type="button"
          className="nt-body-m -mx-4 flex h-12 items-center gap-2 rounded-2xl px-4 text-[#363D36] transition-colors hover:bg-[#F5F6F3] focus-visible:shadow-focus focus-visible:outline-none"
        >
          <Icon name="magnifying-glass" className="text-[#0D110D]" />
          {label || t('text1')}
        </button>
      }
    />
  );
}
